"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineLength = exports.midpointOfLine = exports.angleOfLineInSignedRadians2f = void 0;
const angleOfLineInSignedRadians2f = ({ start, end }) => Math.atan2(end.y - start.y, end.x - start.x);
exports.angleOfLineInSignedRadians2f = angleOfLineInSignedRadians2f;
const midpointOfLine = ({ start, end }) => ({
    x: (end.x + start.x) / 2,
    y: (end.y + start.y) / 2
});
exports.midpointOfLine = midpointOfLine;
const lineLength = ({ start, end }) => Math.sqrt(Math.pow(end.x - start.x, 2) + Math.pow(end.y - start.y, 2));
exports.lineLength = lineLength;
//# sourceMappingURL=line.js.map